import React, { useState, useEffect, useRef } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';

const cor = '#B51013';

export default function BuscaGlobalMobile() {
  const [aberta, setAberta] = useState(false);
  const [texto, setTexto] = useState('');
  const [resultados, setResultados] = useState({ colaboradores: [], cursos: [] });
  const [buscando, setBuscando] = useState(false);
  const navigate = useNavigate();
  const inputRef = useRef();
  const timeoutRef = useRef();

  useEffect(() => {
    if (aberta && inputRef.current) inputRef.current.focus();
  }, [aberta]);

  useEffect(() => {
    clearTimeout(timeoutRef.current);
    if (texto.length < 2) { setResultados({ colaboradores: [], cursos: [] }); setBuscando(false); return; }
    setBuscando(true);
    timeoutRef.current = setTimeout(async () => {
      const termo = texto.toLowerCase();
      try {
        const [colabSnap, cursosSnap] = await Promise.all([
          getDocs(collection(db, 'colaboradores')),
          getDocs(collection(db, 'cursos')),
        ]);
        setResultados({
          colaboradores: colabSnap.docs.map(d => ({ id: d.id, ...d.data() })).filter(c => c.nome?.toLowerCase().includes(termo) || c.email?.toLowerCase().includes(termo)).slice(0, 4),
          cursos: cursosSnap.docs.map(d => ({ id: d.id, ...d.data() })).filter(c => c.ativo !== false && c.nome?.toLowerCase().includes(termo)).slice(0, 4),
        });
      } catch {}
      setBuscando(false);
    }, 350);
  }, [texto]);

  const navegar = (path) => { navigate(path); setAberta(false); setTexto(''); };
  const total = resultados.colaboradores.length + resultados.cursos.length;

  if (!aberta) return (
    <button onClick={() => setAberta(true)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '4px', display: 'flex', alignItems: 'center', color: '#888' }}>
      <svg width="18" height="18" viewBox="0 0 16 16" fill="none">
        <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M11 11l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    </button>
  );

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#fff', zIndex: 500, display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px 16px', borderBottom: '1px solid #e5e5e5' }}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
          <circle cx="7" cy="7" r="5" stroke="#aaa" strokeWidth="1.5"/>
          <path d="M11 11l3 3" stroke="#aaa" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
        <input
          ref={inputRef}
          value={texto}
          onChange={e => setTexto(e.target.value)}
          placeholder="Buscar colaboradores, cursos..."
          style={{ flex: 1, border: 'none', outline: 'none', fontSize: '15px', color: '#1a1a1a' }}
          autoFocus
        />
        <button onClick={() => { setAberta(false); setTexto(''); }} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '15px', color: '#888', padding: '4px' }}>✕</button>
      </div>

      {/* Resultados */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '8px 0' }}>
        {buscando && <div style={{ padding: '20px', textAlign: 'center', color: '#aaa', fontSize: '13px' }}>Buscando...</div>}

        {!buscando && texto.length >= 2 && total === 0 && (
          <div style={{ padding: '20px', textAlign: 'center', color: '#aaa', fontSize: '13px' }}>Nenhum resultado para "{texto}"</div>
        )}

        {resultados.colaboradores.length > 0 && (
          <>
            <div style={{ padding: '6px 16px', fontSize: '10px', fontWeight: '700', color: '#888', letterSpacing: '0.8px' }}>COLABORADORES</div>
            {resultados.colaboradores.map(c => (
              <div key={c.id} onClick={() => navegar(`/colaboradores/${c.id}`)} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px', borderBottom: '1px solid #f5f5f5', cursor: 'pointer' }}>
                <div style={{ width: '36px', height: '36px', borderRadius: '50%', background: cor, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '13px', fontWeight: '600', color: '#fff', flexShrink: 0 }}>
                  {(c.nome || '?').split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase()}
                </div>
                <div>
                  <div style={{ fontSize: '14px', fontWeight: '500', color: '#1a1a1a' }}>{c.nome}</div>
                  <div style={{ fontSize: '12px', color: '#888' }}>{c.funcao}</div>
                </div>
              </div>
            ))}
          </>
        )}

        {resultados.cursos.length > 0 && (
          <>
            <div style={{ padding: '6px 16px', fontSize: '10px', fontWeight: '700', color: '#888', letterSpacing: '0.8px', marginTop: '4px' }}>CURSOS</div>
            {resultados.cursos.map(c => (
              <div key={c.id} onClick={() => navegar(`/treinamento/${encodeURIComponent(c.nome)}`)} style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '12px 16px', borderBottom: '1px solid #f5f5f5', cursor: 'pointer' }}>
                <div style={{ width: '36px', height: '36px', borderRadius: '8px', background: '#FCEBEB', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="2" y="2" width="12" height="12" rx="2" stroke={cor} strokeWidth="1.3" opacity=".6"/><path d="M5 6h6M5 9h4" stroke={cor} strokeWidth="1.2" strokeLinecap="round"/></svg>
                </div>
                <div>
                  <div style={{ fontSize: '14px', fontWeight: '500', color: '#1a1a1a' }}>{c.nome}</div>
                  <div style={{ fontSize: '12px', color: '#888' }}>{c.duracao} · +{c.pts} pts</div>
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
